export default __webpack_public_path__ + "static/jor-6years-46fe64f37c5e66dcdc9be285372a029c.jpg";